import { catalog } from '@nolens/i18n';

/** Página de inscrição para testar (/beta, /teste). */
export const betaText = catalog(
  {
    docTitle: 'Be one of the first to use Nolens Guides',
    eyebrow: 'Early access',
    title: 'Be one of the first to use Nolens Guides',
    lead: 'Document your real procedures with the extension for 2 to 3 weeks, free. Tell us what saves you time and what you miss: your feedback will shape the product.',
    perks: 'Free during the test · Early access · Direct contact with the team',
    email: 'Work email',
    name: 'Name',
    company: 'Company',
    role: 'Your role',
    rolePlaceholder: 'e.g. Operations, HR, Support lead',
    teamSize: 'Team size',
    choose: 'Choose…',
    just: 'Just me',
    area: 'What would you document first?',
    areaPlaceholder: 'e.g. onboarding, accounting procedures, support answers',
    tools: 'Apps you use in the browser',
    toolsPlaceholder: 'e.g. ERP, CRM, government portals, internal tools',
    submit: 'Ask to try it',
    privacy: 'We only use these details to contact you about the test.',
    privacyLink: 'Privacy policy',
    doneTitle: 'Thank you!',
    doneText:
      'We have sent you a confirmation email. In the next few days, we will send you the link to install the extension and your access details.',
    doneNext:
      'In the meantime, you can already create your account: sign in with this email and choose “Start free”. We will turn on Premium access when we send you the extension.',
    doneSignIn: 'Create my account',
    back: 'Back to the product page',
  },
  {
    'pt-PT': {
      docTitle: 'Seja dos primeiros a usar o Nolens Guides',
      eyebrow: 'Acesso antecipado',
      title: 'Seja dos primeiros a usar o Nolens Guides',
      lead: 'Documente os seus procedimentos reais com a extensão durante 2 a 3 semanas, sem pagar. Diga-nos o que lhe poupa tempo e o que lhe faz falta: a sua opinião vai moldar o produto.',
      perks: 'Grátis durante o teste · Acesso antecipado · Contacto direto com a equipa',
      email: 'Email profissional',
      name: 'Nome',
      company: 'Empresa',
      role: 'A sua função',
      rolePlaceholder: 'ex.: Operações, RH, coordenação de apoio ao cliente',
      teamSize: 'Tamanho da equipa',
      choose: 'Escolha…',
      just: 'Só eu',
      area: 'O que documentaria primeiro?',
      areaPlaceholder:
        'ex.: integração de pessoas novas, procedimentos de contabilidade, respostas de apoio',
      tools: 'Aplicações que usa no browser',
      toolsPlaceholder: 'ex.: ERP, CRM, portais públicos, ferramentas internas',
      submit: 'Quero experimentar',
      privacy: 'Só usamos estes dados para o contactar sobre o teste.',
      privacyLink: 'Política de privacidade',
      doneTitle: 'Obrigado!',
      doneText:
        'Enviámos-lhe um email de confirmação. Nos próximos dias, vamos enviar-lhe a ligação para instalar a extensão e os seus acessos.',
      doneNext:
        'Até lá, pode já criar a sua conta: entre com este email e escolha «Começar grátis». Ativaremos o acesso Premium quando lhe enviarmos a extensão.',
      doneSignIn: 'Criar a minha conta',
      back: 'Voltar à página do produto',
    },
  },
);
